import React from 'react'
import clsx from 'clsx'
import styles from './UIGameTradeCreatorActionButtons.module.scss'
import {TradeCreationData, TradeCreationDataValidator} from '@colonist/game-mechanic-validators'
import {UIGameTradeCreatorActionButtonTradeWithBank} from './UIGameTradeCreatorActionButtonTradeWithBank'
import {UIGameTradeCreatorActionButtonTradeWithOpponents} from './UIGameTradeCreatorActionButtonTradeWithOpponents'
import {UIGameActionButtonTrade} from '../../UIGameActionButtonsContainer/UIGameActionButtonTrade'

export interface UIGameTradeCreatorActionButtonsProps {
    className?: string | undefined
    isPortraitLayout?: boolean | undefined
    tradeCreationDataValidator: TradeCreationDataValidator
    getCurrentTradeCreationData: (isBankTrade: boolean) => TradeCreationData
}

export const UIGameTradeCreatorActionButtons = ({
    className,
    isPortraitLayout = false,
    tradeCreationDataValidator,
    getCurrentTradeCreationData,
}: UIGameTradeCreatorActionButtonsProps) => (
    <div className={clsx(styles.tradeCreatorActionsContainer, className, {
        [styles.portraitLayout]: isPortraitLayout,
    })}>
        <UIGameTradeCreatorActionButtonTradeWithBank
            hideTooltip={isPortraitLayout}
            tradeCreationDataValidator={tradeCreationDataValidator}
            getCurrentTradeCreationData={getCurrentTradeCreationData} />
        <UIGameTradeCreatorActionButtonTradeWithOpponents
            hideTooltip={isPortraitLayout}
            tradeCreationDataValidator={tradeCreationDataValidator}
            getCurrentTradeCreationData={getCurrentTradeCreationData} />
        {isPortraitLayout && <UIGameActionButtonTrade className={styles.actionButton} />}
    </div>
)
